import useBreakpoint from '@/hooks/useBreakpoint';

export const useButtonSize = (): 'small' | 'large' => {
  const { isMobile, isTablet, isSmallDesktop } = useBreakpoint();
  const isSmallScreen = isMobile || isTablet || isSmallDesktop;

  return isSmallScreen ? 'small' : 'large';
};
